import {PropsWithChildren} from "react";
import {useSelf} from "../agent/useSelf.ts";
import {useFullOpenTransfersForTruck, useFullScheduledTransfersForDriver} from "../rpc/webrpc-client.gen.ts";
import {BundleStatusRelay} from "../bundle/status.tsx";
import {useMountedTruck} from "./mountedTruck.ts";

export function DriverRelay({children}: PropsWithChildren) {
    const selfTqrv = useSelf();
    const self = selfTqrv.data;
    const canDrive = self?.canDrive;
    const scheduledTransfersTqrv = useFullScheduledTransfersForDriver(canDrive
        ? {driverId: self.id} : undefined);
    const scheduledTransfers = scheduledTransfersTqrv.data;
    const mountedTruckTqrv = useMountedTruck();
    const mountedTruck = mountedTruckTqrv.data;
    const {data: openTruckTransfers} = useFullOpenTransfersForTruck(mountedTruck ? {truckId: mountedTruck.id} : undefined);

    return <>
        {(scheduledTransfers ?? []).map(sxfer => {
            if (sxfer?.bundle) {
                const bundleId = sxfer.bundle.id;
                return <BundleStatusRelay bundleId={bundleId} key={bundleId}/>;
            } else {
                return null;
            }
        })}

        {(openTruckTransfers ?? []).map(xfer => {
            if (xfer?.bundle) {
                const bundleId = xfer.bundle.id;
                return <BundleStatusRelay bundleId={bundleId} key={bundleId}/>;
            } else {
                return null;
            }
        })}

        {children}
    </>
}

